import React, { useState, useRef, useEffect } from 'react';
import './DropdownSearch.css';
import { ThemeSetup } from '../../../themes/ThemeSetup';
import t from '../../../i18n/I18n';
import ThumbnailUtil from '../../../util/ThumbnailUtil';

const DropdownSearch = ({
  options,
  onOptionSelect,
  onOptionRemove,
  onInputChange,
  updateSelectedOptions,
  placeholder = t('DROPDOWN_SEARCH_DEFAULT_PLACEHOLDER'),
  isSingleSelect = false,
  defaultOptions
}) => {
  const [searchTerm, setSearchTerm] = useState(isSingleSelect && defaultOptions && defaultOptions.length > 0 && defaultOptions[0] ?
    defaultOptions[0].getName() : '');
  const [showOptions, setShowOptions] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState(defaultOptions ? defaultOptions : []); // Track selected options
  const inputRef = useRef(null);
  const dropdownRef = useRef(null); // Ref for the dropdown container
  const crossIcon = ThemeSetup.getImageURL('cross-icon.svg');

  // Handle input change
  const handleInputChangeInternal = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    onInputChange(value); // Callback to handle external input changes
    setShowOptions(true); // Show options on input change
  };

  // Handle option select
  const handleOptionSelect = (selectedOption) => {
    if (!selectedOptions.some((option) => option.getId() === selectedOption.getId())) {
      setSelectedOptions([...selectedOptions, selectedOption]); // Add selected option to the list
    }
    onOptionSelect ? onOptionSelect(selectedOption.getId()) : void 0;
    updateSelectedOptions ? updateSelectedOptions(selectedOptions) : void 0;
    if (isSingleSelect) {
      setShowOptions(false);
      setSearchTerm(selectedOption.getName());
    }
  };

  // Handle removal of selected option
  const removeSelectedOption = (optionId) => {
    setSelectedOptions(selectedOptions.filter((option) => option.getId() !== optionId));
    onOptionRemove ? onOptionRemove(optionId) : void 0;
    updateSelectedOptions ? updateSelectedOptions(selectedOptions) : void 0;
  };

  // Close options when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };
    window.addEventListener('click', handleClickOutside);
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div className="dropdown-search" ref={dropdownRef}>
      {/* Display selected options */}
      {
        isSingleSelect ? null :
          <div className={`selected-options ${selectedOptions.length > 0 ? 'add-padding' : ''}`}>
            {selectedOptions.map((selectedOption) => (
              selectedOption && selectedOption.getId() ?
                <div key={selectedOption.getId()} className="selected-option">
                  <img src={selectedOption.getThumbnailSrc()} className="selected-option-image" />
                  <div className="selected-option-label">{selectedOption.getName()}</div>
                  <img
                    src={crossIcon}
                    className="remove-option"
                    onClick={() => removeSelectedOption(selectedOption.getId())}
                  />
                </div> : null
            ))}
          </div>
      }
      {/* Input for search */}
      <input
        ref={inputRef}
        type="text"
        className="search-input"
        placeholder={placeholder}
        value={searchTerm}
        onChange={handleInputChangeInternal}
        onFocus={() => setShowOptions(true)} // Show options on input focus
      // onBlur={() => setShowOptions(false)} // Show options on input focus
      />
      {/* Display options list */}
      {showOptions && options.length > 0 && (
        <ul className="options-list">
          {options.map((option) => (
            <li key={option.getId()} className="option" onClick={() => handleOptionSelect(option)}>
              <img src={option.getThumbnailSrc()} className="option-image" />
              <div className="option-label">{option.getName()}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DropdownSearch;
